import { Typography } from '@mui/material';
import { Tooltip } from 'src/components';

export const ClientName = ({
  fullName,
  onClick,
  tooltipText,
}: {
  fullName: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  tooltipText?: string | ((children: React.ReactNode) => React.ReactNode);
}) => {
  return (
    <Tooltip
      hideWhenRefIsHidden
      title={typeof tooltipText === 'function' ? tooltipText(fullName) : tooltipText}
    >
      <Typography
        variant="subtitle2"
        paddingBlock={1}
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
        sx={{
          ...(!!onClick && { cursor: 'pointer' }),
        }}
        onClick={onClick}
      >
        {fullName}
      </Typography>
    </Tooltip>
  );
};
